import { Link } from 'react-router-dom';

const columns = [
  {
    title: 'Categories',
    links: [
      { label: 'Electronics', to: '/search?category=electronics' },
      { label: 'Gaming', to: '/search?category=gaming' },
      { label: 'Home', to: '/search?category=home' },
      { label: 'Kitchen', to: '/search?category=kitchen' },
      { label: 'Fitness', to: '/search?category=fitness' },
      { label: 'Outdoor', to: '/search?category=outdoor' },
      { label: 'Beauty', to: '/search?category=beauty' },
      { label: 'Smart Home', to: '/search?category=smart-home' },
    ],
  },
  {
    title: 'Guides',
    links: [
      { label: 'Best Headphones', to: '/search?q=headphones' },
      { label: 'Best Laptops', to: '/search?q=laptops' },
      { label: 'Best TVs', to: '/search?q=tv' },
      { label: 'Best Coffee Makers', to: '/search?q=coffee' },
      { label: 'Best Robot Vacuums', to: '/search?q=vacuum' },
      { label: 'Best Smartwatches', to: '/search?q=smartwatch' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us', to: '/about' },
      { label: 'Editorial Standards', to: '/about' },
      { label: 'How We Test', to: '/about' },
      { label: 'Careers', to: '/contact' },
      { label: 'Press', to: '/contact' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Affiliate Disclosure', to: '/about' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Terms of Service', to: '/terms' },
      { label: 'Cookie Preferences', to: '/privacy' },
      { label: 'Accessibility', to: '/contact' },
      { label: 'Help Center', to: '/contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-ink-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid lg:grid-cols-6 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <img src="/buywize-icon.png" alt="" className="w-8 h-8" />
              <span className="font-display text-xl font-bold">
                Buy<span className="text-cta-400">Wize.</span>
              </span>
            </Link>
            <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-sm">
              Independent product reviews, comparisons, and buying guides. We may earn a commission from qualifying purchases.
            </p>
          </div>

          {columns.map((c) => (
            <div key={c.title}>
              <p className="text-sm font-semibold text-white mb-4">{c.title}</p>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.to} className="text-sm text-white/60 hover:text-white transition">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">&copy; 2026 BuyWize, Inc. All prices and availability are current as of publication.</p>
          <div className="flex items-center gap-4 text-xs text-white/50">
            <Link to="/contact" className="hover:text-white transition">Advertise</Link>
            <Link to="/search" className="hover:text-white transition">Sitemap</Link>
            <span className="flex items-center gap-1"><i className="ri-global-line"></i> English (US)</span>
          </div>
        </div>
      </div>
    </footer>
  );
}